// src/pages/Legal/CGV.js
import './LegalPages.css';

import { useDocumentTitle } from '../../hooks/useDocumentTitle';
export default function CGV() {
  useDocumentTitle('Conditions générales de vente');

  return (
    <div className="legal-page">
      <div className="container legal-page__inner">
        <p className="legal-page__overtitle">Conditions commerciales</p>
        <h1 className="legal-page__titre">Conditions Générales de Vente</h1>
        <hr className="divider-or" style={{ margin: '16px 0 40px' }} />

        <section className="legal-section">
          <h2>Article 1 — Objet</h2>
          <p>
            Les présentes Conditions Générales de Vente (CGV) régissent l’ensemble des ventes
            effectuées sur le site lesbazarsdekeassa.com, édité par Les Bazars de Keassa (KEASSA).
            Toute commande passée sur le site implique l’acceptation entière et sans réserve
            des présentes CGV par le client.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 2 — Produits</h2>
          <p>
            Les produits proposés à la vente sont des bijoux fantaisie et des perruques pour femmes.
            Les photographies des produits sont les plus fidèles possible mais ne constituent pas
            un élément contractuel. KEASSA se réserve le droit de modifier ses produits et son
            catalogue à tout moment.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 3 — Prix</h2>
          <p>
            Les prix sont indiqués en euros (EUR) toutes taxes comprises (TTC). KEASSA se réserve
            le droit de modifier ses prix à tout moment. Les produits sont facturés au prix en
            vigueur au moment de la validation de la commande.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 4 — Commande</h2>
          <p>
            Le client passe commande en suivant le processus de commande en ligne :
            sélection des produits, ajout au panier, saisie des informations de livraison et
            paiement. La commande est confirmée par l’envoi d’un email de confirmation
            à l’adresse fournie par le client. KEASSA se réserve le droit de refuser toute
            commande pour un motif légitime.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 5 — Paiement</h2>
          <p>
            Le paiement s’effectue en ligne par carte bancaire via la plateforme sécurisée Stripe.
            Les données de paiement sont chiffrées et ne sont jamais stockées sur les serveurs
            de KEASSA. Le paiement est débité au moment de la confirmation de la commande.
            Stripe est certifié PCI-DSS (Payment Card Industry Data Security Standard).
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 6 — Livraison</h2>
          <p>
            Les produits sont livrés à l’adresse indiquée par le client lors de la commande.
            Les délais de livraison sont de 2 à 5 jours ouvrables pour la France métropolitaine.
            KEASSA ne saurait être tenue responsable des retards de livraison imputables
            au transporteur. Le client sera informé par email de l’expédition de sa commande
            avec un numéro de suivi lorsque celui-ci est disponible.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 7 — Droit de rétractation</h2>
          <p>
            Conformément à l’article L221-18 du Code de la consommation, le client dispose
            d’un délai de <strong>14 jours calendaires</strong> à compter de la réception de sa commande
            pour exercer son droit de rétractation, sans avoir à justifier de motif ni à payer
            de pénalité.
          </p>
          <p>
            Pour exercer ce droit, le client doit notifier sa décision par email à
            contact@lesbazarsdekeassa.com. Les produits doivent être retournés dans leur
            état d’origine, non portés, non lavés, avec leurs étiquettes. Les frais de retour
            sont à la charge du client. Le remboursement sera effectué dans un délai de
            14 jours suivant la réception du produit retourné.
          </p>
          <p>
            <strong>Exceptions :</strong> le droit de rétractation ne s’applique pas aux produits
            personnalisés ou sur mesure, ni aux produits descellés ne pouvant être renvoyés
            pour des raisons d’hygiène (perruques essayées sans bonnet de protection).
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 8 — Garanties</h2>
          <p>
            Tous les produits vendus sur le site bénéficient de la garantie légale de
            conformité (articles L217-4 et suivants du Code de la consommation) et de la
            garantie contre les vices cachés (articles 1641 et suivants du Code civil).
            En cas de produit défectueux ou non conforme, le client peut contacter
            KEASSA pour obtenir un échange ou un remboursement.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 9 — Responsabilité</h2>
          <p>
            KEASSA ne saurait être tenue responsable des dommages de toute nature,
            directs ou indirects, résultant de l’utilisation des produits vendus.
            Les photographies et descriptions des produits ne sont données qu’à titre indicatif.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 10 — Données personnelles</h2>
          <p>
            Les données collectées lors de la commande sont nécessaires au traitement
            de celle-ci et sont traitées conformément au RGPD. Pour plus de détails,
            consultez notre <a href="/politique-confidentialite">Politique de confidentialité</a>.
          </p>
        </section>

        <section className="legal-section">
          <h2>Article 11 — Litiges</h2>
          <p>
            Les présentes CGV sont soumises au droit français. En cas de litige, une
            solution amiable sera recherchée avant tout recours judiciaire. Le client peut
            recourir à un médiateur de la consommation. Les tribunaux de Paris sont
            compétents en cas de litige.
          </p>
        </section>

        <p className="legal-page__update">Dernière mise à jour : Juin 2026</p>
      </div>
    </div>
  );
}